import Vue from 'vue';
import VueMeta from 'vue-meta';
import App from './App.vue';
import router from './router';
import store from './store';

import axios from 'axios';
import VueAxios from 'vue-axios';
import VueGtag from 'vue-gtag';
import VueObserveVisibility from 'vue-observe-visibility';

Vue.use(VueMeta, {
    refreshOnceOnNavigation: true,
});

Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = 'https://data.apenhet.no/api/';

Vue.use(VueObserveVisibility);

if (process.env.NODE_ENV === 'production') {
    Vue.use(
        VueGtag,
        {
            config: { id: 'G-XEBDMJ3627' },
        },
        router
    );
}

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
